import { ReportSummaryItemApi } from "../api/Reports";
import { formattedDate } from "../utils";

interface PrintReportHeaderProps {
  reportSummary: ReportSummaryItemApi;
}

const PrintReportHeader = ({ reportSummary }: PrintReportHeaderProps) => {
  return (
    <div className="hidden print:block w-full text-white relative p-6 bg-gradient-to-r from-gradBlue to-darkBlue rounded-2xl shadow mb-4">
      <div className="flex justify-between gap-4">
        <div className="text-white flex-grow max-w-lg">
          <h1 className="self-stretch text-5xl font-bold leading-none print:text-3xl mb-2">
            {reportSummary.full_name}
          </h1>
          <p className="text-sm font-medium flex flex-col">
            <span>
              <b>Report ID:</b> {reportSummary.report_uuid}
            </span>
          </p>
        </div>
        <div className="name-tag flex flex-col gap-2 p-3 text-center rounded-2xl min-w-max">
          <div>
            Company:{" "}
            <span className="font-bold">{reportSummary.company_name}</span>
          </div>
          <div>
            Client Report ID:
            <span className="font-bold">{reportSummary.client_report_id}</span>
          </div>
          <div>
            Completed:
            <span className="font-bold">
              {formattedDate(reportSummary.finish_at)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrintReportHeader;
